import { createContext } from 'react';

const AdditionalInfoContext = createContext();

export default AdditionalInfoContext;
